import { SimpleDialogUI } from '@sequencehq/core-components'
import { ExtractionData } from 'ContractExtraction/atoms'
import { Text, Link, Flex } from '@chakra-ui/react'
import { add, sub } from '@sequencehq/utils/dates'
import { Loadable } from 'jotai/vanilla/utils/loadable'
import { getSequenceRequestId } from 'ContractExtraction/utils/getSequenceRequestId'

export const ExtractionDebugDialog = ({
  extractionResult,
  setShowDebugModal
}: {
  extractionResult: Loadable<Promise<ExtractionData | null> | null>
  setShowDebugModal: (show: boolean) => void
}) => {
  const sequenceRequestId = getSequenceRequestId(extractionResult)

  if (!sequenceRequestId) {
    return null
  }

  const startTime = sub(new Date(), { minutes: 10 }).toISOString()
  const endTime = add(new Date(), { minutes: 10 }).toISOString()

  return (
    <SimpleDialogUI
      title="Extraction Debug"
      cancelButtonText={null}
      confirmButtonText="Done"
      onConfirm={() => setShowDebugModal(false)}
    >
      <Flex direction="column" gap={4}>
        <Text>
          {extractionResult.state === 'hasError'
            ? (extractionResult.error as Error).message
            : 'Extraction was a success'}
        </Text>
        <Link
          target="_blank"
          href={`https://console.cloud.google.com/logs/query;query=SEARCH%2528%22${sequenceRequestId}%22%2529%0Aresource.type%3D%22http_load_balancer%22%20OR%20resource.type%3D%22cloud_run_revision%22%0Aresource.labels.service_name%3D"billing"%0A--%20SEARCH%2528%22Received%20extracted%20contract%20from%20Gemini%22%2529;startTime=${startTime};endTime=${endTime}?project=non-production-339214&invt=Abt1-g`}
        >
          View logs
        </Link>
      </Flex>
    </SimpleDialogUI>
  )
}
